export default "__VITE_ASSET__4f99726e__"